import { Fragment, useEffect, useState } from "react";
import useAxios from "../../hooks/useAxios";
import List from "./dynamic ui list components/List";
import { PageHeader } from "../../components";

export default function PlatformTenantList() {
  const axios = useAxios();
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios({
      url: "/list/dynamicDashboard",
    }).then((res) => {
      if (res.status) {
        setTenants(res.data);
      }
      setLoading(false);
    });
  }, [axios]);

  return (
    <Fragment>
      <PageHeader pageName="Platform Tenants" />
      <List tenants={tenants} loading={loading} />
    </Fragment>
  );
}
